import {
    RegisterOptions,
    useController,
    useFormContext,
} from "react-hook-form";
import SearchSelect, {
    ISearchSelectProps,
} from "../../CardsPages/Forms/SearchSelect";

export interface IFormSearchSelectProps<T> extends ISearchSelectProps<T> {
    name: string;
    registerOptions?: RegisterOptions;
}

export default function FormSearchSelect<T>(props: IFormSearchSelectProps<T>) {
    const { name, defaultValue, registerOptions, ...searchSelectProps } = props;

    const { control } = useFormContext();

    const {
        field: { ref, ...field },
    } = useController({
        name,
        defaultValue,
        rules: registerOptions,
        control,
    });

    return <SearchSelect {...searchSelectProps} {...field} />;
}
